import React, { useEffect, useState, useRef } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Coins, Shield, Leaf, FileText, Settings, Zap, ChevronDown, ChevronRight, User, LogOut, Bell, LayoutList, Wrench, Users, BookOpen, ScrollText, MessageSquare, Radio, Sliders, Check, CreditCard, PanelLeft, PanelLeftClose, MousePointerClick, Menu, X, AlertCircle, Network } from 'lucide-react';
const SERVICES = [{
  id: 's1',
  name: 'Customer Assistant',
  health: 'healthy' as const
}, {
  id: 's2',
  name: 'Smart Matcher',
  health: 'healthy' as const
}, {
  id: 's3',
  name: 'Content Moderator',
  health: 'warning' as const
}, {
  id: 's4',
  name: 'AI Tutor',
  health: 'healthy' as const
}];
function UserMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={menuRef} data-id="element-493">
      <button onClick={() => setOpen(!open)} className="flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-gray-100 transition-all" data-id="element-494">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face" alt="Marco Rossi" className="w-7 h-7 rounded-full object-cover border border-gray-200" data-id="element-495" />
        <div className="hidden md:flex flex-col items-start" data-id="element-496">
          <span className="font-medium text-gray-700 text-[16px]" data-id="element-497">
            Marco Rossi
          </span>
        </div>
        <ChevronDown className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-498" />
      </button>

      {open && <div className="absolute top-full mt-2 right-0 w-[200px] bg-white border border-gray-200 rounded-xl overflow-hidden shadow-xl z-50" data-id="element-499">
          <div className="px-4 py-3 border-b border-gray-100" data-id="element-500">
            <p className="text-[13px] font-medium text-gray-900" data-id="element-501">Marco Rossi</p>
            <p className="text-[11px] text-gray-500 mt-0.5" data-id="element-502">
              marco.rossi@siae.it
            </p>
          </div>
          <div className="py-1" data-id="element-503">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-all" data-id="element-504">
              <User className="w-4 h-4" data-id="element-505" />
              Il mio profilo
            </button>
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-all" data-id="element-506">
              <Settings className="w-4 h-4" data-id="element-507" />
              Impostazioni
            </button>
          </div>
          <div className="border-t border-gray-100 py-1" data-id="element-508">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-red-600 hover:bg-red-50 transition-all" data-id="element-509">
              <LogOut className="w-4 h-4" data-id="element-510" />
              Esci
            </button>
          </div>
        </div>}
    </div>;
}
function ServiceSelector({
  selectedId,
  onSelect
}: {
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const selected = SERVICES.find(s => s.id === selectedId);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const healthDot = (health: string) => health === 'healthy' ? 'bg-[#00B4D8]' : health === 'warning' ? 'bg-amber-500' : 'bg-red-500';
  return <div className="relative mb-2" ref={ref} data-id="element-511">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2.5 px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg hover:border-gray-300 transition-all" data-id="element-512">
        <div className={`w-2 h-2 rounded-full ${healthDot(selected?.health || 'healthy')} flex-shrink-0`} data-id="element-513" />
        <span className="text-[13px] font-heading font-medium text-gray-700 truncate flex-1 text-left" data-id="element-514">
          {selected?.name || 'Seleziona servizio'}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-515" />
      </button>

      {open && <div className="absolute top-full mt-1.5 left-0 right-0 bg-white border border-gray-200 rounded-xl overflow-hidden shadow-xl z-50" data-id="element-516">
          {SERVICES.map(service => <button key={service.id} onClick={() => {
        onSelect(service.id);
        setOpen(false);
      }} className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-left transition-all ${service.id === selectedId ? 'bg-blue-50 text-[#2A3B5C]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-517">
              <div className={`w-2 h-2 rounded-full ${healthDot(service.health)} flex-shrink-0`} data-id="element-518" />
              <span className="text-[13px] font-heading font-medium truncate flex-1" data-id="element-519">
                {service.name}
              </span>
              {service.id === selectedId && <Check className="w-3.5 h-3.5 text-[#00B4D8] flex-shrink-0" data-id="element-520" />}
            </button>)}
        </div>}
    </div>;
}
export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCanvasPage = false;
  const [sidebarMode, setSidebarMode] = useState<'global' | 'service'>('global');
  const [selectedServiceId, setSelectedServiceId] = useState('s1');
  const [sidebarState, setSidebarState] = useState<'open' | 'closed' | 'hover'>('open');
  const [isHovering, setIsHovering] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [complianceSubmenuOpen, setComplianceSubmenuOpen] = useState(false);
  const effectivelyOpen = sidebarState === 'open' || sidebarState === 'hover' && isHovering;
  const sidebarWidth = effectivelyOpen ? 220 : 64;
  // Auto-open compliance submenu if on a compliance route
  useEffect(() => {
    if (location.pathname.startsWith('/compliance')) {
      setComplianceSubmenuOpen(true);
    }
  }, [location.pathname]);
  const cycleSidebarState = () => {
    setSidebarState(prev => {
      if (prev === 'open') return 'closed';
      if (prev === 'closed') return 'hover';
      return 'open';
    });
    setIsHovering(false);
  };
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  // Auto-switch to service mode
  useEffect(() => {
    const match = location.pathname.match(/^\/servizio\/(\w+)/);
    if (match) {
      setSidebarMode('service');
      setSelectedServiceId(match[1]);
    }
  }, [location.pathname]);
  const handleServiceSelect = (id: string) => {
    setSelectedServiceId(id);
    navigate(`/servizio/${id}`);
  };
  return <div className="flex min-h-screen bg-[#F4F6F8]" data-id="element-521">
      {/* Mobile backdrop */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-522" />}

      {/* Sidebar */}
      <aside className={`fixed left-0 top-0 bottom-0 bg-white border-r border-gray-200 flex flex-col transition-all duration-300 ease-in-out
          ${isMobileMenuOpen ? 'translate-x-0 z-40' : '-translate-x-full lg:translate-x-0 z-40'}
        `} style={{
      width: isMobileMenuOpen ? '280px' : `${sidebarWidth}px`
    }} onMouseEnter={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(true);
    }} onMouseLeave={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(false);
    }} data-id="element-523">
        {/* Logo */}
        <div className="h-20 px-5 pt-4 flex items-center justify-between overflow-hidden bg-white" data-id="element-524">
          {effectivelyOpen || isMobileMenuOpen ? <img src="https://cdn.magicpatterns.com/uploads/ei3TPBS2kJEWcyNVT3MDLH/Nuovo_logo_SIAE.png" alt="SIAE" className="h-12 w-auto object-contain pl-[10px]" data-id="element-525" /> : <div className="w-10 h-10 flex items-center justify-center mx-auto shrink-0 overflow-hidden" data-id="element-526">
              <img src="https://cdn.magicpatterns.com/uploads/ei3TPBS2kJEWcyNVT3MDLH/Nuovo_logo_SIAE.png" alt="SIAE" className="h-10 w-auto object-cover object-left" style={{
            maxWidth: '40px'
          }} data-id="element-527" />
            </div>}
          <button onClick={() => setIsMobileMenuOpen(false)} className="lg:hidden p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all" data-id="element-528">
            <X className="w-5 h-5" data-id="element-529" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-3 space-y-1 overflow-y-auto overflow-x-hidden custom-scrollbar transition-all duration-300 ease-in-out" style={{
        paddingLeft: effectivelyOpen || isMobileMenuOpen ? 16 : 8,
        paddingRight: effectivelyOpen || isMobileMenuOpen ? 16 : 8
      }} data-id="element-530">
          {sidebarMode === 'global' ? <>
              <NavLink to="/costs" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-531">
                <Home className="w-4 h-4 flex-shrink-0" data-id="element-532" />
                <span className="text-[15px]" data-id="element-533">Overview</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-534">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-535">
                    Governance
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-536" />}
              </div>

              {/* Compliance with Submenu */}
              <div data-id="element-537">
                <button onClick={() => {
              if (effectivelyOpen || isMobileMenuOpen) {
                setComplianceSubmenuOpen(!complianceSubmenuOpen);
              } else {
                navigate('/compliance/ai-act');
              }
            }} className={`nav-item w-full${location.pathname.startsWith('/compliance') ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-538">
                  <Shield className={`w-4 h-4 flex-shrink-0 ${location.pathname.startsWith('/compliance') ? 'text-[#00B4D8]' : ''}`} data-id="element-539" />
                  <span className="flex-1 text-left text-[15px]" data-id="element-540">
                    Compliance
                  </span>
                  {(effectivelyOpen || isMobileMenuOpen) && <ChevronRight className={`w-3.5 h-3.5 transition-transform duration-200 ${complianceSubmenuOpen ? 'rotate-90' : ''} ${location.pathname.startsWith('/compliance') ? 'text-gray-800' : 'text-gray-400'}`} data-id="element-541" />}
                </button>

                {/* Submenu */}
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${complianceSubmenuOpen && (effectivelyOpen || isMobileMenuOpen) ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-542">
                  <div className="ml-4 mt-1 space-y-1 border-l border-gray-200 pl-3" data-id="element-543">
                    <NavLink to="/compliance/ai-act" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-544">
                      {({
                    isActive
                  }) => <>
                          <AlertCircle className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-545" />
                          <span data-id="element-546">AI Act</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/gdpr" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-547">
                      {({
                    isActive
                  }) => <>
                          <Shield className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-548" />
                          <span data-id="element-549">GDPR</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/audit" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-550">
                      {({
                    isActive
                  }) => <>
                          <FileText className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-551" />
                          <span data-id="element-552">Audit Trail</span>
                        </>}
                    </NavLink>
                  </div>
                </div>
              </div>

              <NavLink to="/greenops" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="GreenOps" data-id="element-553">
                <Leaf className="w-4 h-4 flex-shrink-0" data-id="element-554" />
                <span className="text-[15px]" data-id="element-555">GreenOps</span>
              </NavLink>

              <NavLink to="/canvas" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="AI Map" data-id="element-556">
                <Network className="w-4 h-4 flex-shrink-0" data-id="element-557" />
                <span className="text-[15px]" data-id="element-558">AI Map</span>
              </NavLink>

              <NavLink to="/reports" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Report" data-id="element-559">
                <FileText className="w-4 h-4 flex-shrink-0" data-id="element-560" />
                <span className="text-[15px]" data-id="element-561">Report</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-562">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-563">
                    Configurazione
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-564" />}
              </div>

              <NavLink to="/providers" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Provider" data-id="element-565">
                <Zap className="w-4 h-4 flex-shrink-0" data-id="element-566" />
                <span className="text-[15px]" data-id="element-567">Provider</span>
              </NavLink>
              <NavLink to="/tools" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Tool" data-id="element-568">
                <Wrench className="w-4 h-4 flex-shrink-0" data-id="element-569" />
                <span className="text-[15px]" data-id="element-570">Tool</span>
              </NavLink>
              <NavLink to="/users" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Fornitori & utenti" data-id="element-571">
                <Users className="w-4 h-4 flex-shrink-0" data-id="element-572" />
                <span className="text-[15px]" data-id="element-573">Fornitori & utenti</span>
              </NavLink>
            </> : <>
              {(effectivelyOpen || isMobileMenuOpen) && <ServiceSelector selectedId={selectedServiceId} onSelect={handleServiceSelect} data-id="element-574" />}

              <div className="h-8 flex items-center overflow-hidden" data-id="element-575">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-576">
                    Servizio
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-577" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}`} end className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-578">
                <LayoutList className="w-4 h-4 flex-shrink-0" data-id="element-579" />
                <span className="text-[15px]" data-id="element-580">Overview</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/config`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Configurazione" data-id="element-581">
                <Sliders className="w-4 h-4 flex-shrink-0" data-id="element-582" />
                <span className="text-[15px]" data-id="element-583">Configurazione</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/canali`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Canali" data-id="element-584">
                <Radio className="w-4 h-4 flex-shrink-0" data-id="element-585" />
                <span className="text-[15px]" data-id="element-586">Canali</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/knowledge`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Knowledge" data-id="element-587">
                <BookOpen className="w-4 h-4 flex-shrink-0" data-id="element-588" />
                <span className="text-[15px]" data-id="element-589">Knowledge</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/strumenti`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Strumenti" data-id="element-590">
                <Wrench className="w-4 h-4 flex-shrink-0" data-id="element-591" />
                <span className="text-[15px]" data-id="element-592">Strumenti</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/istruzioni`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Istruzioni" data-id="element-593">
                <MessageSquare className="w-4 h-4 flex-shrink-0" data-id="element-594" />
                <span className="text-[15px]" data-id="element-595">Istruzioni</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-596">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-597">
                    Analisi
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-598" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}/log`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Log" data-id="element-599">
                <ScrollText className="w-4 h-4 flex-shrink-0" data-id="element-600" />
                <span className="text-[15px]" data-id="element-601">Log</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/costi`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Costi" data-id="element-602">
                <CreditCard className="w-4 h-4 flex-shrink-0" data-id="element-603" />
                <span className="text-[15px]" data-id="element-604">Costi</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/compliance`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-605">
                <Shield className="w-4 h-4 flex-shrink-0" data-id="element-606" />
                <span className="text-[15px]" data-id="element-607">Compliance</span>
              </NavLink>
            </>}
        </nav>

        {/* Bottom toggle (desktop only) */}
        <div className="hidden lg:block p-3 border-t border-gray-200" data-id="element-608">
          <button onClick={cycleSidebarState} className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg hover:bg-gray-50 transition-all group" title={sidebarState === 'open' ? 'Chiudi sidebar' : sidebarState === 'closed' ? 'Sidebar su hover' : 'Apri sidebar'} data-id="element-609">
            <div className="flex-shrink-0" data-id="element-610">
              {sidebarState === 'open' && <PanelLeft className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-611" />}
              {sidebarState === 'closed' && <PanelLeftClose className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-612" />}
              {sidebarState === 'hover' && <MousePointerClick className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-613" />}
            </div>
            <div className="flex items-center gap-2 flex-1 min-w-0 overflow-hidden whitespace-nowrap" data-id="element-614">
              <span className="text-[12px] font-heading font-medium text-gray-500 group-hover:text-gray-900 truncate" data-id="element-615">
                {sidebarState === 'open' ? 'Aperta' : sidebarState === 'closed' ? 'Chiusa' : 'Hover'}
              </span>
              <div className="flex items-center gap-1 ml-auto flex-shrink-0" data-id="element-616">
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'open' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-617" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'closed' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-618" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'hover' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-619" />
              </div>
            </div>
          </button>
        </div>
      </aside>

      {/* Top Bar */}
      {!isCanvasPage && <header className="fixed top-0 right-0 h-14 bg-white/95 backdrop-blur-md border-b border-gray-200 z-30 flex items-center justify-between px-4 lg:px-6 transition-all duration-300 ease-in-out shadow-sm" style={{
      left: window.innerWidth >= 1024 ? `${sidebarWidth}px` : '0'
    }} data-id="element-620">
          <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all" data-id="element-621">
            <Menu className="w-5 h-5" data-id="element-622" />
          </button>

          <div className="hidden lg:block" data-id="element-623" />

          <div className="flex items-center gap-3" data-id="element-624">
            <button className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-all relative" data-id="element-625">
              <Bell className="w-4 h-4" data-id="element-626" />
              <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-627" />
            </button>
            <div className="w-px h-6 bg-gray-200" data-id="element-628" />
            <UserMenu data-id="element-629" />
          </div>
        </header>}

      {/* Main Content */}
      <main className={`flex-1 min-h-screen transition-all duration-300 ease-in-out ${!isCanvasPage ? 'pt-14' : ''}`} style={{
      marginLeft: window.innerWidth >= 1024 ? `${sidebarWidth}px` : '0'
    }} data-id="element-630">
        <Outlet data-id="element-631" />
      </main>
    </div>;
}